export default __webpack_public_path__ + "static/media/rss.2bb2f864.svg";